import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-solid-svg-icons'

import SelectInput from 'components/ui/forms/field/select-input/SelectInput'
import Button, { ButtonColors, ButtonSizes } from 'design-system/button'
import { sortFolderDefault, sortFolderEnum } from 'enum/folder.enum'
import { ICourseModel } from 'models/course.model'
import { useTranslationRankmi } from 'helpers/translations.helper'
import CommonToolTip from 'components/ui/tooltip/commonToolTip'
import { directionsInvert } from './directions'
import { directions } from './directions'
import { FieldOption, Option } from './types'

interface AddSortProps {
  field?: FieldOption
  onSelected: (value?: Partial<FieldOption> | null) => void
  options: Option[]
}

export function AddSort({ field, onSelected, options }: AddSortProps) {
  const tRelative = useTranslationRankmi({
    prefix: 'administration.folders.folder',
  })
  const { option, direction } = { ...field }
  const { value: attribute, aliasKeyLabel: aliasLabel } = { ...option }

  const sort = direction || sortFolderDefault

  const icon = (option?.icons || directions)[sort]
  const invert = directionsInvert[sort]

  const value = field?.option

  type TooltipTranslation = Partial<
    Record<keyof ICourseModel, Partial<Record<sortFolderEnum, string>>>
  >

  const tooltips = tRelative<string, TooltipTranslation>(
    'sortConfiguration.tooltips',
    {
      returnObjects: true,
    }
  )

  const tooltip =
    (attribute && tooltips[aliasLabel || attribute]?.[sort]) ||
    tRelative(`sortConfiguration.directionsDefault.${sort}`)

  return (
    <div className="row">
      <div className="col">
        <SelectInput<Option>
          name="state"
          placeHolder={tRelative('search.placeHolder')}
          options={options}
          closeMenuOnSelect={true}
          isClearable
          value={value}
          isMulti={false}
          withColors={false}
          onChange={(newValue) => {
            if (newValue) onSelected({ option: newValue, direction })
            else onSelected({})
          }}
        />
      </div>
      <div className="col-auto pl-0">
        <div className="d-flex align-items-center h-100">
          <div>
            <CommonToolTip text={tooltip} position="top">
              <Button
                className={`m-0`}
                onClick={() => {
                  attribute &&
                    onSelected({ option: field?.option, direction: invert })
                }}
                size={ButtonSizes.Small}
                color={ButtonColors.Blue}
              >
                <FontAwesomeIcon icon={icon} />
              </Button>
            </CommonToolTip>
          </div>
          <div className="flex-fill" />
          <div
            className="p-2"
            onClick={() => {
              onSelected(null)
            }}
          >
            <div className="d-flex align-items-center h-100">
              <FontAwesomeIcon icon={faTimes} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
